import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { useSubscription } from '../contexts/SubscriptionContext';
import UpgradeModal from './UpgradeModal';
import './PremiumGate.css';

export default function PremiumGate({ feature, children, contextMessage }) {
  const { canUseFeature } = useSubscription();
  const [showUpgrade, setShowUpgrade] = useState(false);

  if (canUseFeature(feature)) {
    return children;
  }

  return (
    <>
      <div className="premium-gate">
        <div className="premium-gate-content" aria-hidden="true">
          {children}
        </div>
        <div className="premium-gate-overlay" onClick={() => setShowUpgrade(true)}>
          <div className="premium-gate-badge">
            <Lock size={14} />
            <span>Premium</span>
          </div>
        </div>
      </div>
      {showUpgrade && (
        <UpgradeModal
          onClose={() => setShowUpgrade(false)}
          contextMessage={contextMessage}
        />
      )}
    </>
  );
}
